module.exports = "/_next/static/images/d0ebeb36e247a8da2aee09fcaf320661-hero-xs.jpg";